module.exports = __webpack_public_path__ + "static/media/hooded-ninja.dabf6363.jpg";